<main>
<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="col-lg-12 col-xl-12 text-left" [ngClass]="{'bgBlue': !newVendor, 'bgMainSection': !newVendor}"  *ngIf="!openConfirmationPage">
    <form [formGroup]="paymentForm">
        <div class="container" formGroupName="paymentDetails" *ngIf="!processPayment">
            <div class="row" *ngIf="!newVendor">
                <div class="col-12 text-left mt-4">
                    <h1 class="mainHeading">Make Payment</h1>
                </div>
            </div>
            <div class="bgWghite pt-2 mt-2 pl-2 pr-2"  [ngClass]="{'shadow': !newVendor}">
              <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 text-left">
                        <div class="row mt-0" *ngIf="enableWifiCodeChangesUfm && applyWIFi">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label class="pure-material-checkbox">
                                    <input type="checkbox" [checked]="true"
                                    formControlName="enableWifiCodeChanges">
                                    <span style="color: black;">WIFI Access</span>
                                </label>
                            </div>
                        </div>
                        <div class="row mt-0" *ngIf="!newVendor">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="priorBalance" i18n>Prior Balance</label>
                                <input type="text" class="form-control text-right" id="priorBalance" readonly formControlName="priorBalance"
                                    (keypress)="numberOnly($event)">
                            </div>
                        </div>
                        <div class="row mt-0">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="rentalCharge" i18n>Rental Charges</label>
                                <input type="text" class="form-control text-right" readonly
                                formControlName="rentalCharge" id="rentalCharge" (keypress)="numberOnly($event)">
                            </div>
                        </div>
                        <div class="row mt-0" *ngIf="!ShowRVDiscount">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="otherCharge" i18n>Other Charges<span *ngIf="showRegistrationFee"> & Registration Fee</span></label>
                                <input type="text" id="otherCharge" class="form-control text-right" readonly
                                formControlName="otherCharge" (keypress)="numberOnly($event)">
                            </div>
                        </div>
                        <div class="row mt-0" *ngIf="enableWifiCodeChangesUfm || applyOtherChargesAutomatically">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="facilityCharge" i18n>Facility Charges</label>
                                <input type="text" id="facilityCharge" class="form-control text-right" readonly
                                formControlName="facilityCharge" (keypress)="numberOnly($event)">
                            </div>
                        </div>
                        <div class="row mt-0" *ngIf="!ShowRVDiscount">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                              <label for="discounts" i18n>Discounts</label>
                              <input type="text" id="discounts" class="form-control text-right" readonly formControlName="discounts"
                              (keypress)="numberOnly($event)">
                            </div>
                        </div>
                        <div class="row mt-0" *ngIf="ShowRVDiscount">
                          <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                            <label for="RVDiscount" i18n>Discounts</label>
                            <input type="text" id="RVDiscount" class="form-control text-right" readonly formControlName="RVDiscount"
                              (keypress)="numberOnly($event)">
                          </div>
                        </div>
                        <div class="row mt-0">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="salesTax" i18n>Sales Tax</label>
                                <input type="text" id="salesTax" class="form-control text-right" readonly
                                formControlName="salesTax" (keypress)="numberOnly($event)">
                            </div>
                        </div>
                        <div class="row mt-0">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="secondTax" i18n>{{secondTaxName}}</label>
                                <input type="text" id="secondTax" class="form-control text-right" readonly
                                formControlName="secondTax" (keypress)="numberOnly($event)">
                            </div>
                        </div>
                        <div class="row mt-0">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="additionalCharges" i18n>Additional Charges</label>
                                <input type="text" id="additionalCharges" class="form-control text-right" readonly formControlName="additionalCharges"
                                    (keypress)="numberOnly($event)">
                            </div>
                        </div>
                         <div class="row mt-0" *ngIf="applyLateFee">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="paymentLateFee" i18n>Late Fee</label>
                                <input type="text" id="paymentLateFee" class="form-control text-right" readonly formControlName="paymentLateFee"
                                    (keypress)="numberOnly($event)">
                            </div>
                        </div>
                        <div class="row mt-0" *ngIf="enablePromoCode">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="promoCode" i18n>Promo Code</label>
                                <div class="d-flex">
                                    <input type="text" id="promoCode" class="form-control text-right mr-1" formControlName="promoCode">
                                    <button type="button" class="btn btn-primary" (click)="applyPromoCodeDiscount()">Apply</button>
                                  </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 text-left">
                        <div class="row mt-0">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="totalDue" i18n>Total Charge</label>
                                <input type="text" id="totalDue" class="form-control text-right" formControlName="totalDue" readonly>
                            </div>
                        </div>
                        <div class="row mt-0">
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                                <label for="paymentAmount" i18n>Payment Amount</label>
                                <input type="text" id="paymentAmount" class="form-control text-right" formControlName="paymentAmount"
                                    (keypress)="numberOnly($event)"
                                    (input)="setCurrencyFormat(paymentForm.controls.paymentDetails.get('paymentAmount'))"
                                    (blur)="setMinimum(paymentForm.controls.paymentDetails.get('paymentAmount'))"
                                    (click)="handleClick($event)" (dblclick)="handledblClick($event)"
                                    (change)="setMinimum(paymentForm.controls.paymentDetails.get('paymentAmount'))">
                            </div>

                    </div>
                    <div class="row mt-0">
                      <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                        <label for="convenienceFee" i18n>Convenience Fee</label>
                        <input id="convenienceFee" type="text" class="form-control text-right" formControlName="convenienceFee"
                               readonly>
                      </div>
                    </div>

                    <div class="row mt-0">
                      <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                        <label for="totalPayment" style="font-weight: 600; font-size: 16px;" i18n>Total Payment</label>
                        <input id="totalPayment" type="text" class="form-control text-right" readonly formControlName="totalPayment">
                      </div>
                    </div>

                    <div class="row mt-0">
                      <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2">
                        <label for="balanceDue" style="font-weight: 600; font-size: 16px;" i18n>Balance Due</label>
                        <input id="balanceDue" type="text" class="form-control text-right" readonly formControlName="balanceDue"
                               (keypress)="numberOnly($event)">
                      </div>
                    </div>
                  </div>
                </div>

                <div formArrayName="rules">
                    <div *ngFor="let rule of rulesFormArray.controls; let i = index" [formGroupName]="i" class="rule-container mt-2">

                        <div class="d-flex">
                            <div class="checkbox-container">
                                <input type="checkbox" [id]="'RulesAndRegulation_'+i" class="CheckboxClass" formControlName="isChecked"
                                    (change)="updateArrayDirectly(i, $event)" />
                            </div>

                            <div class="text-container">
                                <label [for]="'RulesAndRegulation_'+i" class="mb-0">
                                    {{ rule.get('rulesAndRegualtions')?.value }}
                                </label>
                            </div>
                        </div>

                        <div *ngIf="rule.get('AgreementLinkRequired')?.value" class="mt-1">
                            <a [href]="rule.get('AgreementBlobURL')?.value" target="_blank" class="rules">
                                {{ rule.get('AgreementLinkTextContent')?.value }}
                            </a>
                        </div>

                    </div>
                </div>

                <div [hidden]="!CaptureVendorSignature" class="signature-container mt-3">
                  <label for="signatureCanvas" class="signature-label mb-2">Signature:</label>
                  <canvas
                          id="signatureCanvas"
                          #signatureCanvas
                          class="signature-canvas"
                          (mousedown)="startDrawing($event)"
                          (mousemove)="draw($event)"
                          (mouseup)="stopDrawing()"
                          (mouseleave)="stopDrawing()"
                          (touchstart)="startDrawing($event)"
                          (touchmove)="draw($event)"
                          (touchend)="stopDrawing()">
                  </canvas>
                </div>

                  <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right mb-3" style="margin-top: 12px;">
                      <button type="button" i18n class="btn btn-outline-primary mr-1" (click)="clearCanvas()">Clear</button>
                      <button type="button" i18n class="btn btn-outline-primary mr-1" (click)="cancel()">Cancel</button>
                      <button type="button" i18n class="btn btn-primary" (click)="saveRentalWithPayment()" [disabled]="!allCheckboxesCheckedValidator()">Submit</button>
                    </div>
                  </div>
                </div>
              </div>
        </div>

        <div *ngIf="processPayment && isOpenEdgenEnabled">
            <app-payment [VendorId]="vendorId" [keyedInTransaction]="keyedInTransaction" [MarketId]="marketId"
                [CCAmount]="paymentAmount" [TransactionType]="transactionType" [voidPayment]="voidPayment"
                (PaymentResponse)="PaymentResponse($event)" [VerifoneId]="verifoneId"
                (ClosePaymentPage)="ClosePaymentPage($event)"></app-payment>
        </div>

        <div *ngIf="voidPayment && isOpenEdgenEnabled">
            <app-payment [VendorId]="vendorId" [voidPayment]="voidPayment" (PaymentResponse)=voidPaymentResponse()
                [VerifoneId]="verifoneId" [MarketId]="marketId"></app-payment>
        </div>
    </form>
</div>

<div *ngIf="processPayment && isStripeEnabled">
    <app-stripe-payment [VendorId]="vendorId" [keyedInTransaction]="keyedInTransaction" [MarketId]="marketId"
        [CCAmount]="paymentAmount" [TransactionType]="transactionType" [voidPayment]="voidPayment"
        (PaymentResponse)="PaymentResponse($event)" [VerifoneId]="verifoneId"
        (ClosePaymentPage)="ClosePaymentPage($event)" [newVendor]="newVendor" [newVendorInfo]="this.sharedDataService.newVendorContactInfo"></app-stripe-payment>
</div>

<div *ngIf="voidPayment && isStripeEnabled">
    <app-stripe-payment [VendorId]="vendorId" [voidPayment]="voidPayment" (PaymentResponse)=voidPaymentResponse()
        [VerifoneId]="verifoneId" [MarketId]="marketId"></app-stripe-payment>
</div>

<div *ngIf="openConfirmationPage">
    <app-rental-confirmation [VendorId]="vendorId" [newVendor]="newVendor" [AccountReceipId]="accountReceipId" [RentalType]="this.paymentData.RentalType" [SignBase64]="SignBase64"
    [paymentOnly]="paymentOnly"></app-rental-confirmation>
</div>
</main>
